import axios from 'axios';

import getEnvironment from '../../../env-config/get-environment';

const locationClient = axios.create({
    baseURL: getEnvironment().googleMapsUri,
});

export default locationClient;
